// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Settings, XCircle } from "lucide-react";

const RetentionPoliciesTab = ({ retentionPolicies }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold dark:text-slate-100">
          Aufbewahrungsrichtlinien
        </h2>
        <button className="px-4 py-2 bg-green-600 dark:bg-green-500 text-white rounded-lg hover:bg-green-700 dark:hover:bg-green-600 flex items-center">
          <Settings className="w-4 h-4 mr-2" />
          Neue Richtlinie
        </button>
      </div>

      <div className="grid gap-4">
        {retentionPolicies.map((policy) => (
          <div
            key={policy.id}
            className="bg-white dark:bg-slate-800 rounded-lg shadow dark:border dark:border-slate-700 p-6 border"
          >
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <div className="flex items-center mb-2">
                  <h3 className="text-lg font-medium dark:text-slate-100">
                    {policy.name}
                  </h3>
                  <span
                    className={`ml-2 px-2 py-1 rounded-full text-xs font-medium ${
                      policy.isActive
                        ? "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200"
                        : "bg-gray-100 dark:bg-slate-700 text-gray-800 dark:text-slate-300"
                    }`}
                  >
                    {policy.isActive ? "Aktiv" : "Inaktiv"}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-4 text-sm dark:text-slate-300">
                  <div>
                    <span className="font-medium">Datentyp:</span>{" "}
                    {policy.dataType}
                  </div>
                  <div>
                    <span className="font-medium">Aufbewahrungszeit:</span>{" "}
                    {policy.retentionPeriod}{" "}
                    {policy.retentionUnit === "years"
                      ? "Jahre"
                      : policy.retentionUnit === "months"
                        ? "Monate"
                        : "Tage"}
                  </div>
                  <div>
                    <span className="font-medium">Automatisches Löschen:</span>{" "}
                    {policy.autoDelete ? "Aktiviert" : "Deaktiviert"}
                  </div>
                  <div>
                    <span className="font-medium">Rechtsgrundlage:</span>{" "}
                    {policy.legalBasis}
                  </div>
                </div>
              </div>
              <div className="flex space-x-2">
                <button className="p-2 text-gray-600 dark:text-slate-400 hover:text-gray-900 dark:hover:text-slate-200">
                  <Settings className="w-4 h-4" />
                </button>
                <button className="p-2 text-red-600 dark:text-red-400 hover:text-red-900 dark:hover:text-red-300">
                  <XCircle className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RetentionPoliciesTab;
